import AstronautUpsellBanner from '@assets/illustration/AstronautUpsellBanner';
import { Button } from 'geniebook-ui/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import React from 'react';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { ButtonSize } from 'geniebook-ui/dist/components/Button/variant';
import { useSetAtom } from 'jotai';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

const UpsellingBanner = () => {
  const width = useViewWidth();
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });

  const buttonProperties = {
    size: (width < breakpoint.md ? 'sm' : 'md') as ButtonSize,
  };

  return (
    <div
      className={
        'h-fit md:max-h-[97px] lg:max-h-[116px] rounded-xl mt-[24px] bg-gradient-to-r from-[#3F39A2] to-[#19A2C0] px-[16px] md:px-[24px] py-[16px] max-sm:flex-col md:flex'
      }
    >
      <div className={'max-md:hidden'}>
        <AstronautUpsellBanner
          className={'md:max-h-[104px] lg:max-h-[123px] mt-[-23px] ml-[-30px]'}
        />
      </div>
      <div
        className={
          'md:mr-[16px] mx-[0px] mb-0 lg:mb-[16px] max-md:flex md:inline-flex float-right max-md:flex-col w-full md:w-1/2 md:flex-row md:flex-wrap md:content-center md:justify-end md:ml-[14px]'
        }
      >
        <div className={'relative'}>
          <h3
            className={
              "inline-flex max-sm:text-[14px] min-md:text-[16px] font-extrabold font-['Open_Sans'] leading-snug w-full"
            }
          >
            Learn another subject the Geniebook way
          </h3>
          <p
            className={
              "inline-flex text-sm font-normal font-['Open_Sans'] leading-[19px] w-full"
            }
          >
            Get a new subject and start improving today!
          </p>
        </div>
      </div>
      <div
        className={
          'max-md:flex max-md:pt-[16px] md:inline-flex max-md:flex-col md:flex-row w-full md:w-1/2 flex-wrap md:content-center justify-end'
        }
      >
        <Button
          className={`max-md:w-[175px] max-md:!h-[34px] min-lg:min-w-[211px] !font-extrabold max-md:!px-[0px]`}
          variant="primary"
          size={buttonProperties.size}
          onClick={() => setUnlockTrialPopUp(true)}
        >
          <FontAwesomeIcon icon={faLock as IconDefinition} />
          &nbsp;Unlock <span className={'md:hidden'}>&nbsp;a&nbsp;</span> free
          trial
        </Button>
      </div>
    </div>
  );
};

export default UpsellingBanner;
